<template>
    <div class="layer">
        <div class="wrap">
            <Header></Header>
            <div class="content_layer">
                <div class="content">
                    <div id="board_layer">
                        <!-- <Menu></Menu> -->
                        <div class="board_search_wrap">
                            <div class="monitoring_menu">
                                <ul>
                                    <li
                                        v-for="(item, idx) in state.tabMenu"
                                        @click="selectStatus(item.idx)"
                                        :class="item.idx === state.selectStatus ? 'active' : ''"
                                    >
                                        <p>{{ item.label }}</p>
                                        <p>{{ numberFormat(state.statusCnt[item.key]) }}</p>
                                    </li>
                                </ul>
                            </div>
                            <Filter
                                :isMonitoring="false"
                                :nation="false"
                                :selectOption="state.selectOption"
                                @search="filterSearch"
                                @reset="resetSearch"
                            ></Filter>
                        </div>
                        <div class="board_top">
                            <div class="board_top_btns">
                                <button type="button" class="board_btn delete" @click="deleteCheckLists()">삭제</button>
                                <button type="button" class="board_btn board_ico_btn" @click="excelDownLoad">
                                    <span>엑셀다운로드</span>
                                    <img src="@/assets/board/excel_ico.png" alt="" />
                                </button>
                            </div>
                            <div class="board_top_btns_right">
                                <div class="count">
                                    총
                                    <span>{{ numberFormat(state.totalLength) }}건</span>
                                </div>

                                <select name="" id="" class="select" v-model.number="state.perPage">
                                    <option value="20">20</option>
                                    <option value="50">50</option>
                                    <option value="70">70</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                        </div>

                        <div class="board_list monitoring_list">
                            <div class="board_cate_btns">
                                <!--<button type="button" @click="updateCheckLists(1)">유통</button>-->
                                <button type="button" @click="updateCheckLists(2)">분석완료</button>
                                <button type="button" @click="updateCheckLists(3)">삭제요청완료</button>
                                <!-- <button type="button" @click="updateCheckLists(4)">삭제완료</button> -->
                                <!-- 일괄변경 버튼 -->
                                <!-- <button type="button" @click="updateCheckLists(5)">안전</button> -->
                            </div>

                            <div class="board_action_btns monitoring_board" style="align-items: center">
                                <button type="button" class="btn_blue" @click="multiReport()">신고하기</button>

                                <p class="mt_in_tit">유형</p>
                                <div class="mt_in_flex">
                                    <select
                                        class="select"
                                        v-model.number="state.typeIdx"
                                        @change="state.detailIdx = getDetailTypeFilter(state.typeIdx)[0].idx"
                                        style="padding-right: 40px"
                                    >
                                        <option :value="type.idx" v-for="type in state.typeList">
                                            {{ type.name }}
                                        </option>
                                    </select>
                                </div>
                                <p class="mt_in_tit">세부 유형</p>
                                <div class="mt_in_flex">
                                    <select class="select" v-model.number="state.detailIdx" style="padding-right: 40px">
                                        <option :value="dType.idx" v-for="dType in getDetailTypeFilter(state.typeIdx)">
                                            {{ dType.name }}
                                        </option>
                                    </select>
                                </div>
                                <button type="button" @click="updateState()">유형 일괄변경</button>
                            </div>

                            <table class="board_table monitoring_board">
                                <colgroup>
                                    <col width="3%" />
                                    <col width="6%" />
                                    <col width="auto" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>
                                            <label class="chk">
                                                <input type="checkbox" v-model="state.isAllCheck" @change="toggleAll" />
                                                <span></span>
                                            </label>
                                        </th>
                                        <th>연번</th>
                                        <th>내용 및 검색정보</th>
                                    </tr>
                                </thead>
                                <tbody v-if="!state.isLoading">
                                    <tr class="" v-for="(item, idx) in list.data">
                                        <td>
                                            <label class="chk">
                                                <input type="checkbox" v-model="state.checkedList" :value="item.idx" />
                                                <span></span>
                                            </label>
                                        </td>
                                        <td>{{ item.idx }}</td>
                                        <td>
                                            <div class="mt_con">
                                                <div class="mt_con_left">
                                                    <div class="thumb_box">
                                                        <div class="thumb" @click="isDetailModal(idx)">
                                                            <img
                                                                :class="{ blur: item.imgPath }"
                                                                :src="item.imgPath ? item.imgPath : require('@/assets/common/NoImg.png')"
                                                            />
                                                            <button type="button">
                                                                <img v-if="item.sns === 1" src="@/assets/sns/twitter_ico.png" />
                                                                <img v-if="item.sns === 2" src="@/assets/sns/google_ico.png" />
                                                                <img v-if="item.sns === 3" src="@/assets/sns/naver_ico.png" />
                                                                <img v-if="item.sns === 4" src="@/assets/sns/youtube_ico.png" />
                                                                <img v-if="item.sns === 5" src="@/assets/sns/instargram_ico.png" />
                                                                <img v-if="item.sns === 6" src="@/assets/sns/bluesky_ico.png" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div class="mt_con_list left">
                                                        <p>
                                                            <span><b>고유번호</b></span>
                                                            <span>{{ item.srIdx }}</span>
                                                        </p>
                                                        <p>
                                                            <span>글쓴이(계정)</span>
                                                            <span>{{ item.author ? item.author : "" }}</span>
                                                        </p>
                                                        <p>
                                                            <span>메신저ID</span>
                                                            <span>
                                                                {{ item.messengerId ? item.messengerId : "" }}
                                                            </span>
                                                        </p>
                                                        <p>
                                                            <span>전화번호</span>
                                                            <span>{{ item.phoneNum ? item.phoneNum : "" }}</span>
                                                        </p>
                                                        <p class="mt_in">
                                                            <span>키워드</span>
                                                            <span>{{ item.keyword }}</span>
                                                        </p>
                                                    </div>
                                                    <div class="mt_con_list right">
                                                        <p>
                                                            <span>내용</span>
                                                            <span v-html="item.title"></span>
                                                        </p>
                                                        <p>
                                                            <span>해시태그</span>
                                                            <span v-html="item.hashtag"></span>
                                                        </p>
                                                        <p>
                                                            <span>URL</span>
                                                            <span v-if="item.siteUrl">
                                                                <a :href="item.siteUrl" target="_blank">
                                                                    {{ item.siteUrl }}
                                                                </a>
                                                            </span>
                                                        </p>
                                                        <p class="mt_in_btns info_btn">
                                                            <button type="button" class="more_btn" @click="openMoreInfo(idx)">
                                                                상세보기
                                                            </button>
                                                            <button
                                                                type="button"
                                                                class="report_btn"
                                                                @click="showReportForm(item)"
                                                                :class="item.isReport === 1 ? 'success' : ''"
                                                            >
                                                                <div
                                                                    class="report_fail"
                                                                    v-if="item.isReport === 1 && item.reportState === 2"
                                                                >
                                                                    <img
                                                                        :src="require('@/assets/common/fail.png')"
                                                                        title="신고에 실패했습니다."
                                                                    />
                                                                </div>
                                                                <img
                                                                    :src="
                                                                        item.isReport !== 1
                                                                            ? item.sns === 1 || item.sns === 4 || item.sns === 6
                                                                                ? require('@/assets/common/report.png')
                                                                                : require('@/assets/common/mail.png')
                                                                            : item.sns === 1 || item.sns === 4 || item.sns === 6
                                                                              ? require('@/assets/common/report_wh.png')
                                                                              : require('@/assets/common/mail_wh.png')
                                                                    "
                                                                    alt=""
                                                                />
                                                            </button>
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="mt_con_right">
                                                    <!-- <div>
                                                        <p class="mt_in_tit">메모</p>
                                                        <textarea name="" placeholder="내용을 입력하세요." v-model="item.memo"></textarea>
                                                    </div> -->
                                                    <ul>
                                                        <li class="mt_in_flex">
                                                            <div>
                                                                <p class="mt_in_tit">유형</p>
                                                                <select
                                                                    class="select"
                                                                    v-model.number="item.type"
                                                                    @change="item.detailType = getDetailTypeFilter(item.type)[0].idx"
                                                                >
                                                                    <option :value="type.idx" v-for="type in state.typeList">
                                                                        {{ type.name }}
                                                                    </option>
                                                                </select>
                                                            </div>
                                                            <div>
                                                                <p class="mt_in_tit">세부유형</p>
                                                                <div class="mt_in_flex">
                                                                    <div class="mt_in_flex">
                                                                        <select class="select" v-model.number="item.detailType">
                                                                            <option
                                                                                :value="dType.idx"
                                                                                v-for="dType in getDetailTypeFilter(item.type)"
                                                                            >
                                                                                {{ dType.name }}
                                                                            </option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <input type="text" v-if="item.detailType === 6" v-model="item.detail" />
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div class="mt_in_flex">
                                                                <div class="mt_in_btns">
                                                                    <button type="button" class="deep_blue_btn" @click="saveList(idx)">
                                                                        저장
                                                                    </button>
                                                                    <!-- <button type="button" class="blue_btn" @click="openLog(item.idx)">
                                                                        기록보기
                                                                    </button> -->
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-if="state.isLoading">
                                    <tr>
                                        <td colspan="3">
                                            <Spinner></Spinner>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-if="list.data.length === 0 && !state.isLoading">
                                    <tr>
                                        <td colspan="3">
                                            <NoResult></NoResult>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="board_bottom">
                            <div class="board_action_btns2">
                                <!--<button type="button" @click="updateCheckLists(1)">유통</button>-->
                                <button type="button" @click="updateCheckLists(2)">분석완료</button>
                                <button type="button" @click="updateCheckLists(3)">삭제요청완료</button>
                                <!-- <button type="button" @click="updateCheckLists(4)">삭제완료</button> -->
                                <!-- 일괄변경 버튼 -->
                                <!-- <button type="button" @click="updateCheckLists(5)">안전</button> -->
                            </div>

                            <div class="board_action_btns2 monitoring_board" style="align-items: center">
                                <button type="button" class="btn_blue" @click="multiReport()">신고하기</button>

                                <p class="mt_in_tit">유형</p>
                                <div class="mt_in_flex">
                                    <select
                                        class="select"
                                        v-model.number="state.typeIdx"
                                        style="padding-right: 40px"
                                        @change="state.detailIdx = getDetailTypeFilter(state.typeIdx)[0].idx"
                                    >
                                        <option :value="type.idx" v-for="type in state.typeList">
                                            {{ type.name }}
                                        </option>
                                    </select>
                                </div>
                                <p class="mt_in_tit">세부 유형</p>
                                <div class="mt_in_flex">
                                    <select class="select" v-model.number="state.detailIdx" style="padding-right: 40px">
                                        <option :value="dType.idx" v-for="dType in getDetailTypeFilter(state.typeIdx)">
                                            {{ dType.name }}
                                        </option>
                                    </select>
                                </div>
                                <button type="button" @click="updateState()">유형 일괄변경</button>
                            </div>
                        </div>
                        <PageBtn
                            v-if="list.data.length !== 0 && !state.isLoading"
                            :currentPage="state.currentPage"
                            :totalLength="state.totalLength"
                            :perPage="state.perPage"
                            @onPaging="handlePageChange"
                        ></PageBtn>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Popup :show="state.isPopupOpen" :title="modal.title" :content="modal.content" @close="modalClose"></Popup>
    <ModalComponents
        :show="state.isModalOpen"
        :title="modal.title"
        :type="modal.type"
        :no="modal.cancel"
        :yes="modal.confirm"
        :data="modal.reportData"
        :customClass="modal.customClass"
        :useBtn="true"
        @close="modalClose"
    ></ModalComponents>
</template>
<script lang="ts">
    import {
        apiService,
        Filter,
        globalStore,
        Header,
        Menu,
        onMounted,
        reactive,
        returnCode,
        userStore,
        watch,
        numberFormat,
        NoResult,
        PageBtn,
        Popup,
        formatDate,
        router,
        Spinner,
        detailInfo,
        resultInfo,
        moreInfo,
        ModalComponents,
        dateFormat,
        res,
    } from "@/BaseComponent";

    export default {
        props: [],
        components: {
            Header,
            Menu,
            PageBtn,
            Filter,
            NoResult,
            Popup,
            Spinner,
            ModalComponents,
        },
        setup() {
            const global = globalStore();
            const user = userStore();
            const { changeCode } = returnCode();
            const state = reactive({
                isLoading: true as boolean,
                isModalOpen: false as boolean,
                isPopupOpen: false as boolean,
                isAllCheck: false as boolean,
                checkedList: [] as Array<number>,
                totalLength: 0 as number,
                typeList: [] as Array<any>,
                detailTypeList: [] as Array<any>,
                perPage: 100 as number,
                currentPage: 1 as number,
                filterData: [] as any,
                selectDate: [] as Array<any>,
                selectOption: [
                    { idx: 1, text: "키워드" },
                    { idx: 2, text: "내용" },
                    { idx: 3, text: "URL" },
                    { idx: 4, text: "글쓴이" },
                    { idx: 5, text: "고유번호" },
                ] as Array<any>,
                tabMenu: [
                    { key: "cntAll", label: "전체", idx: -1 },
                    { key: "analyzingCnt", label: "분석중", idx: 0 },
                    { key: "monitoringCnt", label: "분석완료", idx: 2 },
                    { key: "unDelCnt", label: "미삭제리스트", idx: 6 },
                    { key: "delReqCnt", label: "삭제요청 완료", idx: 3 },
                    // { key: "delCompCnt", label: "삭제완료", idx: 4 },
                    { key: "safeCnt", label: "해당없음", idx: 5 },
                    // { key: "distCnt", label: "유통", idx: 1 },
                ],
                statusCnt: {
                    cntAll: 0,
                    safeCnt: 0,
                    distCnt: 0,
                    monitoringCnt: 0,
                    delReqCnt: 0,
                    delCompCnt: 0,
                    unDelCnt: 0,
                    analyzingCnt: 0,
                } as any,
                selectStatus: -1 as number | null,
                typeIdx: 0 as number,
                detailIdx: 0 as number,
            });
            const list = reactive({
                data: [] as Array<any>,
            });
            const modal = reactive({
                selectIdx: null as number | null,
                actionCode: null as number | null,
                type: "" as string,
                customClass: [] as any,
                confirm: "",
                cancel: "",
                reportData: {} as any,
                title: "" as string,
                content: {
                    title: "",
                    main: {
                        title: "",
                        data: "",
                        render: () => {
                            return "";
                        },
                    },
                    subTitle: "",
                    sub: {
                        title: "",
                        data: "",
                        render: () => {
                            return "";
                        },
                    },
                } as any,
            });

            const resetModalData = () => {
                modal.content = {
                    title: "",
                    main: {
                        title: "",
                        data: "",
                        render: () => {
                            return "";
                        },
                    },
                    subTitle: "",
                    sub: {
                        title: "",
                        data: "",
                        render: () => {
                            return "";
                        },
                    },
                };
            };

            const selectDate = (date: any) => {
                state.selectDate = date;
            };

            onMounted(() => {
                state.typeList = global.type;
                state.detailTypeList = global.detailType;
                const startDate = new Date(new Date().setDate(new Date().getDate() - 7));
                const endDate = new Date();
                state.selectDate = [startDate, endDate];
                global.setSelectMenu(2);
            });

            watch(
                () => state.perPage,
                () => {
                    user.setPerPage(state.perPage);
                    state.currentPage = 1;
                    getMonitList();
                },
            );

            watch(
                () => state.checkedList,
                () => (state.isAllCheck = state.checkedList.length === list.data.length),
            );

            const getStatusCnt = async () => {
                let status = 0 as number | null;
                if (state.selectStatus === -1) {
                    status = null;
                } else {
                    status = state.selectStatus;
                }
                const res = await apiService.monitoring.getStatusCnt(status, state.currentPage, state.perPage, state.filterData);
                if (res.returnCode === 0) {
                    state.statusCnt = res.data;
                } else if (res.returnCode !== 11) {
                    alert(changeCode(res.returnCode));
                }
            };

            const getMonitList = async () => {
                state.isLoading = true;
                let status = 0 as number | null;
                if (state.selectStatus === -1) {
                    status = null;
                } else {
                    status = state.selectStatus;
                }
                const res = await apiService.monitoring.getMonitList(status, state.currentPage, state.perPage, state.filterData);
                if (res.returnCode === 0) {
                    list.data = res.list.data;
                    state.totalLength = res.list.recordsTotal;
                    list.data.forEach((item: any, i: number) => {
                        item.type === 2 ? (item.resultState = 5) : null;
                    });
                    getStatusCnt();
                } else if (res.returnCode !== 11) {
                    alert(changeCode(res.returnCode));
                }
                state.isLoading = false;
            };

            const excelDownLoad = async () => {
                let status = 0 as number | null;
                if (state.selectStatus === -1) {
                    status = null;
                } else {
                    status = state.selectStatus;
                }

                const res: any = await apiService.excel.monitoringList(status, state.currentPage, state.perPage, state.filterData);
                if (res.status === 200) {
                    const blob = res.data;
                    const fileUrl = URL.createObjectURL(blob);
                    const link = document.createElement("a");

                    link.download =
                        "모니터링_" +
                        dateFormat(new Date(global.searchDate[0])) +
                        " - " +
                        dateFormat(new Date(global.searchDate[1])) +
                        ".xlsx";
                    link.href = fileUrl;
                    link.click();
                    URL.revokeObjectURL(fileUrl);
                    return alert("다운로드 완료 되었습니다.");
                } else {
                    console.error(res);
                    alert("다운로드 중 오류가 발생했습니다.");
                }
            };

            const selectStatus = (idx: number) => {
                state.selectStatus = idx;
                state.currentPage = 1;
                getMonitList();
            };

            const filterSearch = (data: any) => {
                state.filterData = data;
                state.currentPage = 1;
                getMonitList();
            };

            const resetSearch = (data: any) => {
                state.currentPage = 1;
                state.filterData = data;
                getMonitList();
            };

            const handlePageChange = (page: number) => {
                state.currentPage = page;
                getMonitList();
            };

            const saveList = (idx: number) => {
                if (list.data[idx].detailType === 6) {
                    if (list.data[idx].detail === null) {
                        return alert("기타 선택 시 값은 필수입니다.");
                    }
                    if (list.data[idx].detail?.trim() === "") {
                        return alert("세부유형의 상세 값을 확인해주세요");
                    }
                } else {
                    list.data[idx].detail = "";
                }
                if (list.data[idx].detailType === null) {
                    return alert("세부유형을 선택해주세요");
                }
                if (list.data[idx].memo === null) {
                    list.data[idx].memo = "";
                }
                saveMonitoring(idx);
            };

            const saveMonitoring = async (idx: number) => {
                const res = await apiService.monitoring.saveMonitoring(
                    list.data[idx].idx,
                    list.data[idx].memo,
                    list.data[idx].type,
                    list.data[idx].detailType,
                    list.data[idx].detail,
                    list.data[idx].resultState,
                    list.data[idx].monitoringPerHour,
                    list.data[idx].isMonitoring,
                );
                if (res.returnCode === 0) {
                    state.filterData.searchContent = "";
                    getMonitList();
                    return alert("저장 완료되었습니다.");
                } else if (res.returnCode !== 11) {
                    return alert(changeCode(res.returnCode));
                }
            };

            const toggleAll = () => {
                if (state.isAllCheck) state.checkedList = list.data.map((item) => item.idx);
                else state.checkedList = [];
            };

            const updateCheckLists = async (status: number) => {
                if (state.checkedList.length > 0) {
                    if (confirm("선택한 모니터링을 수정하시겠습니까?")) {
                        const res = await apiService.monitoring.updateMonitorings(state.checkedList.join(", "), status);
                        if (res.returnCode === 0) {
                            getMonitList();
                            // getStatusCnt();
                            alert("수정 완료되었습니다.");
                        } else if (res.returnCode !== 11) {
                            alert(changeCode(res.returnCode));
                        }
                    }
                } else {
                    return alert("선택된 목록이 없습니다.");
                }
            };

            const getDetailInfo = async (idx: number) => {
                const res = await apiService.search.detailInfo(idx);
                if (res.returnCode === 0) {
                    modal.content.main.data = res.data;
                } else {
                    modal.content.main.data = changeCode(res.returnCode);
                    modal.content.subTitle = "";
                    modal.content.main.render = (data: any) => data;
                }
            };

            const getResultDetail = async (idx: number) => {
                const res = await apiService.search.getResultDetail(idx);
                if (res.returnCode === 0) {
                    modal.content.sub.data = res.data;
                } else {
                    changeCode(res.returnCode);
                }
            };

            const getMonitoringLog = async (idx: number) => {
                const res = await apiService.monitoring.getMonitoringLog(idx);
                if (res.returnCode === 0) {
                    modal.content.main.data = res.list;
                }
            };

            const modalClose = (result: any, data: any) => {
                if (result) {
                    switch (modal.actionCode) {
                        case 2:
                            reportEmail(data ? data : null);
                            break;
                        case 3:
                            reportPlatform(data);
                            break;
                    }
                }
                state.isPopupOpen = false;
                state.isModalOpen = false;
                resetModalData();
            };

            const reportEmail = async (data: any) => {
                if (data) {
                    const res = await apiService.report.email(modal.selectIdx, data);
                    if (res.returnCode === 0) {
                        alert("이메일 전송이 완료 되었습니다");
                        list.data.find((item) => item.idx === modal.selectIdx).isReport = 1;
                    } else {
                        alert(changeCode(res.returnCode));
                    }
                }
            };

            const reportPlatform = async (data: any) => {
                let res = {} as res;
                if (data.sns === 1 && modal.selectIdx) {
                    res = await apiService.report.twitter(modal.selectIdx);
                } else if (data.sns === 4 && modal.selectIdx) {
                    res = await apiService.report.youtube(modal.selectIdx);
                } else if (data.sns === 6 && modal.selectIdx) {
                    res = await apiService.report.bluesky(modal.selectIdx);
                }

                if (res && res.returnCode === 0) {
                    alert("신고가 완료 되었습니다");
                    list.data.find((item) => item.idx === modal.selectIdx).isReport = 1;
                } else if (res && res.returnCode) {
                    alert(changeCode(res.returnCode));
                }
            };

            const openMoreInfo = (idx: number) => {
                getDetailInfo(list.data[idx].siIdx);
                state.isPopupOpen = true;
                modal.title = "상세보기";
                modal.content.main.class = "";
                modal.content.main.render = (data: any) => {
                    return moreInfo(data);
                };
            };

            const isDetailModal = (idx: number) => {
                getDetailInfo(list.data[idx].siIdx);
                getResultDetail(list.data[idx].srIdx);
                state.isPopupOpen = true;
                modal.title = "검색조건";
                modal.content.main.class = "thumb_con";
                modal.content.main.title = "검색정보";
                modal.content.main.render = (data: any) => {
                    return detailInfo(data);
                };
                modal.content.subTitle = "검색결과";
                modal.content.sub.class = "thumb_con";
                modal.content.sub.render = (data: any) => {
                    let type = state.typeList.find((item: any) => item.idx === data.type)?.name;
                    let detailType = "";
                    detailType =
                        data.detailType !== 6
                            ? state.detailTypeList.find((item: any) => item.idx === data.detailType)?.name
                            : `기타(${data.detail})`;

                    return resultInfo(data, type, detailType);
                };
            };

            const navigateToRedist = (idx: number) => {
                if (list.data[idx].cntDeploy === 0) return alert("재유포 기록이 없습니다.");
                if (list.data[idx].cntDeploy === null) return alert("재유포 기록이 없습니다.");
                router.push("/redistribution/" + list.data[idx].idx);
            };

            const openLog = (idx: number) => {
                getMonitoringLog(idx);
                modal.title = "로그";
                modal.content.main.class = "";
                modal.content.main.render = (data: any) => {
                    let html = "변경된 기록이 없습니다." as string;
                    const logDate = (date: any) => {
                        const year = date.getFullYear();
                        const month = String(date.getMonth() + 1).padStart(2, "0"); // 월은 0부터 시작하므로 +1
                        const day = String(date.getDate()).padStart(2, "0");
                        const hours = String(date.getHours()).padStart(2, "0");
                        const minutes = String(date.getMinutes()).padStart(2, "0");
                        const seconds = String(date.getSeconds()).padStart(2, "0");

                        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
                    };
                    if (data && data.length !== 0) {
                        html = "";
                        for (let i = 0; i < data.length; i++) {
                            html += `<li>
                                       <span>${logDate(new Date(data[i].createDate))}</span>
                                       <p>${data[i].strState}</p>
                                   </li>`;
                        }
                    }
                    return `<ul class="pop_log_list">
                       ${html}
                       </ul>
                   `;
                };
                state.isPopupOpen = true;
            };

            const deleteCheckLists = async () => {
                if (state.checkedList.length > 0) {
                    if (confirm("선택한 모니터링을 삭제하시겠습니까?")) {
                        const res = await apiService.monitoring.deleteMonitorings(state.checkedList.join(","));
                        if (res.returnCode === 0) {
                            alert("삭제 완료되었습니다.");
                            getMonitList();
                        } else if (res.returnCode !== 11) {
                            return alert(changeCode(res.returnCode));
                        }
                    }
                } else {
                    return alert("선택된 목록이 없습니다.");
                }
            };

            const multiReport = async () => {
                if (state.checkedList.length > 0) {
                    const idxList = list.data
                        .filter((item) => state.checkedList.includes(item.idx) && [1, 4, 6].includes(item.sns))
                        .map((item) => item.idx);

                    if (idxList.length > 0) {
                        if (!confirm("선택된 게시글을 신고하시겠습니까?")) return;
                        const res = await apiService.report.multiReport(idxList.join(", "));
                        if (res.returnCode === 0) {
                            alert("신고 완료되었습니다.");
                            getMonitList();
                        } else if (res.returnCode !== 11) {
                            alert(changeCode(res.returnCode));
                        }
                    } else {
                        alert("일괄신고는 X(구 트위터), 유튜브, 블루스카이 플랫폼만 가능합니다.");
                    }
                } else {
                    alert("선택된 게시글이 없습니다.");
                }
            };

            const updateState = async () => {
                if (state.checkedList.length > 0) {
                    if (state.typeIdx === -1 && state.detailIdx === -1) return alert("변경할 유형 또는 세부 유형을 선택해주세요.");
                    const params = {
                        idxList: state.checkedList.join(", "),
                        typeIdx: state.typeIdx,
                        detailIdx: state.detailIdx,
                    };
                    const res = await apiService.monitoring.updateMonitoringsForType(params);
                    if (res.returnCode === 0) {
                        getMonitList();
                        state.typeIdx = -1;
                        state.detailIdx = -1;
                    } else if (res.returnCode !== 11) {
                        alert(changeCode(res.returnCode));
                    }
                } else {
                    return alert("선택된 목록이 없습니다.");
                }
            };

            const showReportForm = (item: any) => {
                getReporpLog(item);
                modal.selectIdx = item.idx;
                if (item.sns === 1 || item.sns === 4 || item.sns === 6) {
                    modal.title = "신고하기";
                    modal.type = "report";
                    modal.customClass = {
                        wrap: ["report_wrap"],
                    };
                    modal.confirm = "신고하기";
                    modal.cancel = "취소";
                    modal.actionCode = 3;
                } else {
                    modal.title = "메일 보내기";
                    modal.type = "email";
                    modal.customClass = {
                        wrap: ["email_wrap"],
                    };
                    modal.confirm = "전송하기";
                    modal.cancel = "취소";
                    modal.actionCode = 2;
                }
                state.isModalOpen = true;
            };

            const getReporpLog = async (item: any) => {
                const res = await apiService.report.getDetail(item.idx);
                if (res.returnCode === 0) {
                    modal.reportData = res.data;
                    modal.reportData.sns = item.sns;
                }
            };

            const getDetailTypeFilter = (typeIdx: number) => {
                return state.detailTypeList.filter((item) => item.typeIdx === typeIdx);
            };

            return {
                state,
                list,
                selectDate,
                selectStatus,
                filterSearch,
                resetSearch,
                numberFormat,
                handlePageChange,
                saveList,
                toggleAll,
                updateCheckLists,
                modal,
                modalClose,
                isDetailModal,
                openMoreInfo,
                navigateToRedist,
                openLog,
                deleteCheckLists,
                formatDate,
                showReportForm,
                multiReport,
                updateState,
                excelDownLoad,
                getDetailTypeFilter,
            };
        },
    };
</script>

<style>
    .monitoring_menu ul li {
        cursor: pointer;
    }

    #board_layer .board_btn.delete {
        width: 65px;
    }

    .monitoring_board .mt_con_list p span:last-child > a {
        text-underline-position: from-font;
        color: #5c5c5c;
    }

    .monitoring_board .mt_con_right .mt_in_tit > span {
        text-decoration: underline;
        text-underline-position: from-font;
        cursor: pointer;
    }

    .mt_con_list {
        min-width: 250px;
    }

    .monitoring_board .thumb > img {
        object-fit: contain;
    }
</style>
<style scoped>
    .email_btn {
        border: 1px solid #4a7dfe !important;
        background-color: #4a7dfe !important;
        color: #fff !important;
    }
    .report_btn {
        flex: none !important;
        cursor: pointer;
        min-width: 40px;
        color: #4a7dfe;
        border: 1px solid #4a7dfe;
        background-color: #fff;
        font-size: 14px;
        cursor: pointer;
        position: relative;
    }

    .report_btn > .report_fail {
        position: absolute;
        top: -40%;
        right: -30%;
    }
    .report_btn > .report_fail > img {
        width: 20px;
        cursor: default;
    }

    .report_btn.success {
        background-color: #4a7dfe;
    }

    #board_layer .monitoring_board .mt_in_btns.info_btn {
        display: flex;
        width: 100%;
        gap: 10px;
    }
    .monitoring_board .mt_con_list p span:last-child {
        line-height: 1.3;
    }

    .btn_blue {
        background-color: #4a7dfe !important;
        color: #fff !important;
    }

    .monitoring_board .mt_con_list p span:first-child {
        word-break: keep-all;
        white-space: normal;
    }
    .monitoring_board .mt_con_list p.mt_in span:last-child {
        display: flex;
        align-items: center;
    }

    #board_layer .monitoring_board .mt_con_right .mt_in_btns button {
        max-width: 150px;
    }

    .mt_con_right textarea {
        width: 300px;
    }

    .mt_con_left {
        min-width: 950px;
    }
    .mt_con_right {
        min-width: 300px;
    }

    .board_bottom {
        width: 100%;
        display: flex;
        justify-content: space-between;
        border-top: 1px solid #dfdfdf;
        background-color: #fff;
        gap: 20px;
    }

    .mt_con_list.left {
        max-width: 250px;
    }
</style>
